import Configuration from '/configuration/index.js';

const configuration = Configuration.get();
const loadedPaths = {};

class CSSLoader {

  static async load(path) {

    const status = loadedPaths[path];

    if (status === true) {
      return;
    } else if (status instanceof Promise) {
      return status;
    }

    loadedPaths[path] = new Promise(function(resolve, reject) {

      let link = document.createElement('link');

      link.href = configuration.cdnAddress + path;
      link.rel = 'stylesheet';

      link.onload = () => resolve(link);
      link.onerror = () => reject(new Error(`Style load error for ${path}`));

      document.head.append(link);

    });

    return loadedPaths[path];

  }

  static async loadAbsolute(path) {

    const status = loadedPaths[path];

    if (status === true) {
      return;
    } else if (status instanceof Promise) {
      return status;
    }

    loadedPaths[path] = new Promise(function(resolve, reject) {

      let link = document.createElement('link');

      link.href = path;
      link.rel = 'stylesheet';

      link.onload = () => resolve(link);
      link.onerror = () => reject(new Error(`Style load error for ${path}`));

      document.head.append(link);

    });

    return loadedPaths[path];

  }

}

export class StylesLoader {

  async loadStyles() {

    const promises = [];
    const styles = this.styles;

    for (let style of styles) {

      promises.push(CSSLoader.load(style));

    }

    return Promise.all(promises);

  }

}

export default CSSLoader;